import { Permissions, TAppNameEnum, TUserAccessMap } from '@onesource/schemas';

export const hasAppAccess = (access: TUserAccessMap | undefined | null, appId: TAppNameEnum): boolean => {
  const permissions = access?.[appId]?.permissions ?? [];
  return permissions.some(p => p.name === Permissions.APP_ACTIVE);
};
